import { Model } from './model';
import { Type } from 'class-transformer';
import { DeductionReason } from './deduction_reason';
import { Vendor } from './vendor';
import { InventoryItem } from './inventory_item';

export type ApprovalStatus = 'approved' | 'rejected' | 'pending';

export class ClaimLineItem extends Model {
  id: string;

  approval_status: ApprovalStatus;

  currency: string;

  external_name: string;

  fee: number;

  price: number;

  quantity: number;

  @Type(() => DeductionReason)
  reason: DeductionReason | null;

  @Type(() => InventoryItem)
  item: InventoryItem | null;

  reason_id: string;

  sku: string;

  total_amount: number;

  unit: string;

  upc: string;

  @Type(() => Vendor)
  vendor: Vendor | null;

  vendor_id: string | null;

  item_id: string | null;

  match_reasoning: string | null;

  match_candidates: { id: string; name: string; vendor: { id: string; name: string } }[] | null;

  get approved() {
    return this.approval_status === 'approved';
  }

  get rejected() {
    return this.approval_status === 'rejected';
  }

  get pending() {
    return this.approval_status === 'pending';
  }
}
